
import Header from "../Common/Header";
import Footer from "../Common/Footer";
function Banking() {
  return (
   <>
   <Header />
    {/* Start Our Features area */}
    <div className="features-area pt-100 pb-70 bgcolor">
      <div className="container">
        <div className="section-title">
          
          <h2>Banking Services</h2>
        </div>
        <div className="row">
        <div className="col-lg-12 col-sm-12 col-md-12">
          <div class="section-title leftalign">
            
        <span className="">Banking</span>
          </div>
          </div>

          </div>
          <div className="row parent">
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card" id="ser1">
            <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                                <img src="assets/images/proicon/credit-card.svg"  />
                            </div>
                            <h3>Credit Cards</h3>
                        </div>
                        <p>Apply for Credit Card Online & Get Instant Approval</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>

                    </div>

          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card" id="ser2">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/bankaccount.svg"  />
                            </div>
                            <h3>Bank Accounts</h3>
                        </div>
                        <p>Open Bank savings account from your home</p>
                        <a href="#" class="default-btn">Apply Now</a>
                        </div>
                    </div>


          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card" id="ser3">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/personal-loan.svg"  />
                            </div>
                            <h3>Personal Loan</h3>
                        </div>
                        <p>You can get a personal loan online instantly</p>
                        <a href="#" class="default-btn">Apply Now</a>
                        </div>
                    </div>
          
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card" id="ser4">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/home-loan.svg"  />
                            </div>
                            <h3>Housing Loan</h3>
                        </div>
                        <p>You can get a Housing loan online instantly

</p>
                        <a href="#" class="default-btn">Apply Now</a>
                        </div>
                    </div>
          

          </div>

          <div className="col-lg-3 col-sm-6 col-md-6">

<div class="services-three-card" id="ser5">
<div className="child">
              <div class="services-card d-flex align-items-center">
                  <div class="services-icon bg-icon-color">
                  <img src="assets/images/proicon/business-loan.svg"  />
                  </div>
                  <h3>
                  Business Loan</h3>
              </div>
              <p>You can get a Business loan online instantly</p>
              <a href="#" class="default-btn">Apply Now</a>
          </div>
          </div>



</div>
<div className="col-lg-3 col-sm-6 col-md-6">
<div class="services-three-card" id="ser6">
<div className="child">
              <div class="services-card d-flex align-items-center">
                  <div class="services-icon bg-icon-color">
                  <img src="assets/images/proicon/professional-loan.svg"  />
                  </div>
                  <h3>Professional Loan</h3>
              </div>
              <p>You can get a Professional loan online instantly</p>
              <a href="#" class="default-btn">Apply Now</a>
          </div>
</div>

</div>
<div className="col-lg-3 col-sm-6 col-md-6">
<div class="services-three-card" id="ser7">
<div className="child">
              <div class="services-card d-flex align-items-center">
                  <div class="services-icon bg-icon-color">
                  <img src="assets/images/proicon/gold-loan.svg"  />
                  </div>
                  <h3>Gold Loan</h3>
              </div>
              <p>You can get a Gold loan online instantly</p>
              <a href="#" class="default-btn">Apply Now</a>
          </div>
          </div>

</div>
<div className="col-lg-3 col-sm-6 col-md-6">

<div class="services-three-card" id="ser8">
<div className="child">
              <div class="services-card d-flex align-items-center">
                  <div class="services-icon bg-icon-color">
                  <img src="assets/images/proicon/car-loan.svg"  />
                  </div>
                  <h3>Vehical Loan</h3>
              </div>
              <p>You can get a Vehical loan online instantly

</p>
              <a href="#" class="default-btn">Apply Now</a>
          </div>
          </div>


</div>

<div className="col-lg-3 col-sm-6 col-md-6">

<div class="services-three-card" id="ser9">
<div className="child">
              <div class="services-card d-flex align-items-center">
                  <div class="services-icon bg-icon-color">
                  <img src="assets/images/proicon/micro-loan.svg"  />
                  </div>
                  <h3>Micro Loans (Under ₹50K)</h3>
              </div>
              <p>Unlock Best Personal Loan Offers suitable for your needs from 30+ Lenders


</p>
              <a href="#" class="default-btn">Apply Now</a>
          </div>
</div>

</div>


        </div>



      </div>
      <div className="container pt-100">
        <div className="section-title">
          
          <h2>Insurance Services</h2>
        </div>
       
        <div className="row">
        <div className="col-lg-12 col-sm-12 col-md-12">
          <div class="section-title leftalign">
            
        <span className="">Insurance Services </span>
          </div>
          </div>
          </div>
          <div className="row parent">
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card" id="ser10">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/moter-insurance.svg"  />
                            </div>
                            <h3>Motor Insurance
                            </h3>
                        </div>
                        <p>Get Additional Protection On Your Car With Add Ons

</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
</div>


          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card" id="ser11">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/life-insurance-policy.svg"  />
                            </div>
                            <h3>Life Insurance
                            </h3>
                        </div>
                        <p>1 Cr Life Cover @Rs 473/Month* Cheapest Prices,


                        </p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>

</div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card" id="ser12">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/health-insurance.svg"  />
                            </div>
                            <h3>Health Insurance
                            </h3>
                        </div>
                        <p>Health insurance plans covers medical expenses

</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          </div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card" id="ser13">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/group-insurance.svg"  />
                            </div>
                            <h3>Group Insurance
                            </h3>
                        </div>
                        <p>Group Insurance policy covers a professional



</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          
</div>
          </div>



        </div>


      </div>
      <div className="container pt-100">
        <div className="section-title">
          
          <h2>Wallet Services</h2>
        </div>
     
        <div className="row">
        <div className="col-lg-12 col-sm-12 col-md-12">
          <div class="section-title leftalign">
            
        <span className="">Wallet Services
        </span>
          </div>
          </div>

          </div>
          <div className="row parent">
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card" id="ser14">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/payment.svg"  />
                            </div>
                            <h3>AePS
                            </h3>
                        </div>
                        <p>Aadhaar Enabled Payment System (AePS)



</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
</div>


          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card" id="ser15">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/bharat-pay.svg"  />
                            </div>
                            <h3>BBPS

                            </h3>
                        </div>
                        <p>Pay Bills On Bharat Bill Payment System


                        </p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>

</div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card" id="ser16">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/recharge.svg"  />
                            </div>
                            <h3>Recharges
                            </h3>
                        </div>
                        <p>Fast & easy mobile recharge online

</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          </div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card" id="ser17">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/home-loan.svg"  />
                            </div>
                            <h3>DMT
                            </h3>
                        </div>
                        <p>Send money to your loved ones instantly</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          
</div>
          </div>



        </div>

      </div>

      <div className="container pt-100">
        <div className="section-title">
          
          <h2>G2C Services</h2>
        </div>
        <div className="row">
        <div className="col-lg-12 col-sm-12 col-md-12">
          <div class="section-title leftalign">
            
        <span className="">G2C Services
        </span>
          </div>
          </div>
          </div>
          <div className="row parent">
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card" id="ser18">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/passport.svg"  />
                            </div>
                            <h3>Passport
                            </h3>
                        </div>
                        <p>An official document issued by a governmernt

</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
</div>


          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card" id="ser19">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/marriage-certificate.svg"  />
                            </div>
                            <h3>Marriage Certificate


                            </h3>
                        </div>
                        <p>Get registered and apply for Marriage Certificate




                        </p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
</div>

          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">
          <div class="services-three-card" id="ser20">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/driving-license.svg"  />
                            </div>
                            <h3>Driving Licence

                            </h3>
                        </div>
                        <p>Now apply for Driving Licence through NDLS



</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          </div>
          </div>
          <div className="col-lg-3 col-sm-6 col-md-6">

          <div class="services-three-card" id="ser21">
          <div className="child">
                        <div class="services-card d-flex align-items-center">
                            <div class="services-icon bg-icon-color">
                            <img src="assets/images/proicon/cast-certificate.svg"  />
                            </div>
                            <h3>Caste Certificate

                            </h3>
                        </div>
                        <p>Now apply for Caste Certificate online

</p>
                        <a href="#" class="default-btn">Apply Now</a>
                    </div>
          </div>

          </div>

          <div className="col-lg-3 col-sm-6 col-md-6">

<div class="services-three-card" id="ser22">
<div className="child">
              <div class="services-card d-flex align-items-center">
                  <div class="services-icon bg-icon-color">
                  <img src="assets/images/proicon/income-certification.svg"  />
                  </div>
                  <h3>Income Certificate

                  </h3>
              </div>
              <p>This certificate establishes the annual income



</p>
              <a href="#" class="default-btn">Apply Now</a>
          </div>

</div>

</div>
<div className="col-lg-3 col-sm-6 col-md-6">
<div class="services-three-card" id="ser23">
<div className="child">
              <div class="services-card d-flex align-items-center">
                  <div class="services-icon bg-icon-color">
                  <img src="assets/images/proicon/domicile-certificate.svg"  />
                  </div>
                  <h3>Domicile Certificate



                  </h3>
              </div>
              <p>Domicile certificate or residence certificate


              </p>
              <a href="#" class="default-btn">Apply Now</a>
          </div>
</div>

</div>
<div className="col-lg-3 col-sm-6 col-md-6">
<div class="services-three-card" id="ser24">
<div className="child">
              <div class="services-card d-flex align-items-center">
                  <div class="services-icon bg-icon-color">
                  <img src="assets/images/proicon/birth-certificate.svg"  />
                  </div>
                  <h3>Birth Certificate
                  </h3>
              </div>
              <p>Birth Certificate. Documents Required for Certificate

</p>
              <a href="#" class="default-btn">Apply Now</a>
          </div>

</div>
</div>

        </div>


      </div>
    </div>
    {/* End Our Features area */}
  
    <Footer />
   </>
  );
}

export default Banking;
